export default "__VITE_ASSET__a4194e23__"